import {
  newConfirm
} from 'trunks/vue/admin/components/libs/confirm.js';

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import EditOrganizationModal from '../hierarchical_list/edit_organization_modal.js';

import MoveOrganizationModal from '../hierarchical_list/move_organization_modal.js';

import OrganizationState from 'trunks/vue/admin/components/organizations/organization_state.js';

export var node_change_mixins = {
  methods: {
    onOrganizationSelected: function(organization) {
      return this.$emit('organizationSelected', organization);
    },
    onOrganizationDeleted: function(organization) {
      return this.$emit('organizationDeleted', organization);
    }
  }
};

export var select_node_mixins = {
  methods: {
    editOrganizationName: function() {
      var el;
      this.togglePopover();
      el = Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('edit-organization-name');
      return new EditOrganizationModal({
        el: el,
        propsData: {
          node: this.node,
          successCallback: (data) => {
            this.node.name = data.organizationName;
            if (this.selected) {
              return OrganizationState.name = this.node.name;
            }
          }
        }
      });
    },
    moveOrganization: function() {
      var el;
      this.togglePopover();
      el = Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('move-organization');
      return new MoveOrganizationModal({
        el: el,
        propsData: {
          organization: this.node
        }
      });
    },
    deleteOrganization: function() {
      this.togglePopover();
      return newConfirm({
        icon: "<i class='slp-warning-circle-o'></i>",
        title: '是否删除此组织',
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'danger',
        message: `确认删除后，${this.node.name}组织下的所有组织将一同删除`
      }).$on('ensureClicked', () => {
        return Skylark.Libs.Ajax.delete(`/admin/organizations/${this.node.id}`, {
          contentType: 'application/json; charset=utf-8',
          responseType: 'json',
          success: () => {
            newAlertify('删除组织成功', {
              type: 'success'
            });
            return this.$emit('organizationDeleted', this.node);
          },
          error: function() {
            return newAlertify('删除组织失败', {
              type: 'error'
            });
          }
        });
      });
    }
  }
};
